<template>
    <div>
        <Info :productLibraryInfo="productLibraryInfo"></Info>
    </div>
</template>
<script>
import Info from './Info.vue'
export  default {
    components: {
        Info
    },
    data(){
        return {
            productLibraryInfo: {
                main:true,
                published:false,
                type: 1,
                basicInfo:{
                    name:"",
                    contractName:"",
                    alias:[],
                    sellingPoints:"",
                    description:[],
                    companyId: '',
                    tags:[],
                    waitingPeriod: '',
                    coolingOffPeriod: ''
                },
                requirement:{
                    role: '',
                    conditionSet:{
                        min: 2,
                        max: 2,
                        conditions:[
                            {
                                type:"conditionAge",
                                params:{
                                    min:{
                                        day: 0,
                                        month: 0,
                                        year: 0
                                    },
                                    max:{
                                        day: 0,
                                        month: 0,
                                        year: 0
                                    }
                                }
                            },
                            {
                                type:"conditionOccupation",
                                params:{
                                    occupations:[]
                                }
                            }
                        ]
                    }
                },
                validPeriodOptions:[],
                payMethodOptions:[],
                amount: {
                    range: true,
                    options: ['', ''],
                    step: ''
                },
            },
        }
    }
}
</script>

